import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _tagged_template_literal from "@swc/helpers/src/_tagged_template_literal.mjs";
function _templateObject() {
    var data = _tagged_template_literal([
        ""
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
import styled from "styled-components";
import { Button } from "@miro-site/core";
var TransparentButton = styled(Button).attrs(function(props) {
    return {
        $styles: _object_spread({}, props.theme.templates.buttons.transparent)
    };
}).withConfig({
    componentId: "sc-c36f0936-0"
})(_templateObject());
export default TransparentButton;
